<template>
  <ul
    v-if="trip"
    class="h-fit flex flex-wrap gap-2 list-none text-xs font-medium !pointer-events-none"
  >
    <RedesignAccomCardTag
      v-if="tags.discount"
      as="li"
      class="inline-flex bg-hlt-hover text-hlt-contrast"
    >
      <span class="truncate">{{ tags.discount }}%</span>
    </RedesignAccomCardTag>

    <RedesignAccomCardTag
      v-if="tags.topRated"
      as="li"
      class="inline-flex bg-suc text-suc-contrast uppercase"
    >
      <span class="truncate">{{ $t(`${trPrefix}toprated`) }}</span>
    </RedesignAccomCardTag>

    <RedesignAccomCardTag
      v-if="tags.new"
      as="li"
      class="inline-flex bg-suc text-suc-contrast uppercase"
    >
      <span class="truncate">{{ $t(`${trPrefix}new`) }}</span>
    </RedesignAccomCardTag>

    <RedesignAccomCardTag
      v-if="tags.freeCancellation"
      as="li"
      class="inline-flex gap-1 bg-suc-reduced border border-suc capitalize"
    >
      <WebccIcon name="site/tick" class="text-suc h-4 w-4 shrink-0" />
      <span class="truncate">{{ $t(`${trPrefixFreeCancellation}short`) }}</span>
    </RedesignAccomCardTag>

    <RedesignAccomCardTag
      v-if="tags.duration"
      as="li"
      class="inline-flex bg-bgr opacity-80 text-xs font-semibold"
    >
      <span class="truncate">{{ tags.duration }}</span>
    </RedesignAccomCardTag>
  </ul>
</template>

<script setup lang="ts">
import { pick } from 'lodash-es'

const trPrefix = 'www.components.hitbox.Tags.'
const trPrefixFreeCancellation = 'plugins.components.FreeCancellationInfo.'

const props = defineProps<{
  accom?: ResultDocument
  trip?: TripParams | Trip
  tags: (keyof RedesignAccomTags)[]
}>()

const freeCancellation = useFreeCancellation(
  () => props.trip,
  () => props.accom?.cancelConditions,
)

const tags = computed<RedesignAccomTags>(() => {
  return pick(
    {
      discount: props.accom?.trip?.reduction?.toFixed(),
      topRated: props.accom?.tags.includes('top'),
      new: props.accom?.tags.includes('new'),
      duration:
        props.trip && formatDateRange(getTripDateRange(props.trip), 'monthDay'),
      freeCancellation: freeCancellation.isEnabled,
    },
    props.tags,
  )
})
</script>
